export default "__VITE_ASSET__DGw7whdw__"